export default __webpack_public_path__ + "static/media/icon_phone.4d821d37.svg";